
<template>
    <v-card v-if="downloadDialog.show"
      height="auto"
      class="top-right-dialog"
      max-width="400"
      prepend-icon="mdi-update"
      :text="downloadDialog.text || $t('components.dialog.download.text')"
      :title="downloadDialog.title || $t('components.dialog.download.title')"
    >
      <v-expand-transition>
        <v-card
          v-if="downloadDialog.revealComplete"
          class="position-absolute w-100"
          height="100%"
          prepend-icon="mdi-check-circle-outline"
          :title="downloadDialog.reveal_title || $t('components.dialog.download.reveal_title')"
          :text="downloadDialog.reveal_text || $t('components.dialog.download.reveal_text')"
          color="success"
          variant="elevated"
          style="bottom: 0;"
        >
        </v-card>
      </v-expand-transition>
    </v-card>
</template>

<script>
export default {
  name: "DownloadDialog",
  computed: {
    downloadDialog() {
      return this.$store.getters['userInterface/getDownloadDialog'];
    },
  },
}
</script>


<style scoped>
.top-right-dialog {
  position: fixed !important;
  bottom: 16px !important;
  right: 16px !important;
  margin: 0 !important;
  box-shadow: 0 0 12px rgba(0,0,0,0.33);
}
</style>
